var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticClass: "ma-n1"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', _vm._b({
      key: item.text,
      staticClass: "pa-1",
      attrs: {
        "cols": _vm.detect == 'mobile' ? 4 : 3
      }
    }, 'v-col', item.props_col, false), [_c('v-responsive', _vm._b({}, 'v-responsive', {
      aspectRatio: _vm.detect == 'mobile' ? 1 : undefined
    }, false), [_c('v-btn', _vm._b({
      staticClass: "transparent",
      staticStyle: {
        "border-radius": "8px!important"
      },
      attrs: {
        "icon": "",
        "block": "",
        "color": "primary",
        "to": item.link
      }
    }, 'v-btn', {
      height: _vm.detect == 'mobile' ? '100%' : undefined
    }, false), [_c('v-layout', _vm._b({}, 'v-layout', {
      'align-center': true,
      'justify-center': true,
      column: _vm.detect == 'mobile',
      style: {
        gap: _vm.detect == 'pc' ? '8px' : '12px'
      }
    }, false), [_c('v-icon', {
      attrs: {
        "large": _vm.detect == 'mobile'
      }
    }, [_vm._v(" " + _vm._s(item.icon) + " ")]), _c('span', {
      staticClass: "font-weight-bold grey--text text--darken-2"
    }, [_vm._v(" " + _vm._s(item.text) + " ")])], 1)], 1)], 1)], 1)];
  }), _vm.detect == 'mobile' ? _c('v-col', {
    attrs: {
      "cols": "12",
      "order": "12"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "border-radius": "8px !important"
    },
    attrs: {
      "x-large": "",
      "block": "",
      "to": "/center/notifications"
    }
  }, [_c('span', [_vm._v("고객센터")])])], 1) : _vm._e()], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }